import { createTheme } from "@mui/material";
const theme = (context) => {
    let mainColor = "#54DE7E"
    let textColor = "#fff"
    if (context && context.mainColor) {
        mainColor = context.mainColor
    }
    if (context && context.textColor) {
        textColor = context.textColor
    }
    return createTheme({
        palette: {
            primary: {
                main: mainColor,
            },
            textColor: {
                main: textColor
            }
        },
        components: {
            MuiGrid: {
                styleOverrides: {
                    root: {
                        paddingLeft: "10px",
                    },
                    container: {
                        paddingRight: "10px"
                    }
                }
            },
        },
        typography: {
            headerLinkName: {
                fontWeight: "normal",
                fontSize: "1rem",
                marginLeft: "1rem",
                color: textColor,
            },
            body: {
                fontSize: "1.05rem",
            },
            title: {
                fontSize: "1.25rem",
                fontWeight: "bold",
                textTransform: "uppercase",
                textAlign: "center",
                color: textColor,
            },
            note: {
                fontSize: "1.05rem",
                fontWeight: "bold",
                color: "#979797",
                textAlign: "center"
            },
            subNote: {
                fontSize: "0.9rem",
                fontWeight: "bold",
                color: "#979797",
                textAlign: "center"
            },
            subHighlight: {
                fontSize: "0.9rem",
                fontWeight: "bold",
                color: "blue",
                textAlign: "center"
            },
            titleCard: {
                fontSize: "1.2rem",
                fontWeight: "bold",
            },
        },
    });
}
export default theme;